import { Query, QueryResult } from '@apollo/client/react/components';
import * as React from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Loader } from './Loader';
export const CSVTest = (props: any) => {
  const [download, setDownload] = React.useState(false);
  const grid = props.grid;
  grid.csv = true;
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const extension = '.xlsx';
  const fileName = new Date().toLocaleString() + extension;

  const downloadData = () => {
    if (!download) {
      return null;
    } else {
      return (
        <Query query={props.query} variables={grid} fetchPolicy='network-only'>
          {(results: QueryResult) => {
            if (results.data) {
              const sheet = XLSX.utils.json_to_sheet(results.data[props.queryName].data);
              const book = { Sheets: { data: sheet }, SheetNames: ['data'] };
              const excel = XLSX.write(book, {
                bookType: 'xlsx',
                type: 'array',
              });
              const excelData = new Blob([excel], { type: fileType });
              saveAs(excelData, fileName);
              setDownload(false);
            }

            return <Loader />;
          }}
        </Query>
      );
    }
  };

  return (
    <React.Fragment>
      <button className='btn btn-block btn-outline-secondary' onClick={() => setDownload(true)} title='Download current grid to spreadsheet'>
        {download ? <div className='spinner-border spinner-border-sm' role='status' /> : <i className='fas fa-external-link-alt' />}
      </button>
      {downloadData()}
    </React.Fragment>
  );
};
